(function () {
    'use strict';

    var el = document.getElementById('gorace-zimne-config');
    if (!el) { return; }
    var cfg = JSON.parse(el.textContent);
    var T = cfg.t;

    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var jestEn = function () { return /^en(?:-|$)/i.test(document.documentElement.lang || ''); };
    var f2raw = function (v) { return (Math.round(v * 100) / 100).toFixed(2).replace('.', jestEn() ? '.' : ','); };
    var fmt = function (v, d) {
        if (v == null || isNaN(v)) { return '—'; }
        var cz = Number(v).toFixed(d).split('.');
        return tys(cz[0]) + (d > 0 ? (jestEn() ? '.' : ',') + cz[1] : '');
    };

    // Zakres lat: suma SUROWYCH licznikow `main` z rocznikow (plan V2 §5.3);
    // e, sd, z liczone tu z model.p. Bez modelu — null, nie zero.
    window.PEWNIAKI_ANALIZA = {
        plik: cfg.plik,
        wersja: cfg.wersja,
        lata: cfg.lata,
        pula: cfg.pula,
        typuje: cfg.typuje,
        p: cfg.p,
        sumujLata: function (roczniki) {
            var hits = {}, N = 0, pula = window.PEWNIAKI_ANALIZA.pula || 0, p = window.PEWNIAKI_ANALIZA.p;
            roczniki.forEach(function (r) {
                N += r.losowan || 0;
                Object.keys(r.main || {}).forEach(function (n) { hits[n] = (hits[n] || 0) + (r.main[n] || 0); });
            });
            // liczba bez wpisu w roczniku nie padla w nim ani razu — to prawdziwe zero
            if (N > 0) { for (var i = 1; i <= pula; i++) { if (hits[i] == null) { hits[i] = 0; } } }
            var maModel = p != null && N > 0, e = maModel ? N * p : null, sd = maModel ? Math.sqrt(N * p * (1 - p)) : null;
            var liczby = {}, maxZ = null;
            Object.keys(hits).forEach(function (n) {
                var z = (maModel && sd > 0) ? (hits[n] - e) / sd : null;
                if (z != null && (maxZ == null || Math.abs(z) > maxZ)) { maxZ = Math.abs(z); }
                liczby[n] = { hits: hits[n], e: e, z: z };
            });
            return { losowan: N, liczby: liczby, e: e, sd: sd, max_z: maxZ, poza: null, powod: null };
        },
        wnioski: function (o, klucz, dane) {
            if (!o || !o.liczby || !Object.keys(o.liczby).length) { return [T.brakZ]; }
            var liczby = o.liczby, pula = (dane && dane.pula) || window.PEWNIAKI_ANALIZA.pula;
            var klucze = Object.keys(liczby).map(Number);
            var gor = klucze.slice().sort(function (a, b) { return liczby[b].hits - liczby[a].hits || a - b; })[0];
            var zim = klucze.slice().sort(function (a, b) { return liczby[a].hits - liczby[b].hits || a - b; })[0];
            var zdanie = function (n, wzor) {
                var w = liczby[n];
                var s = wzor.replace('%1', n).replace('%2', tys(w.hits)).replace('%3', tys(o.losowan));
                if (w.z == null) { return s + T.brakM; }
                s += ', z = ' + f2raw(w.z);
                return s + (Math.abs(w.z) < 2 ? T.wNorm : T.poza2.replace('%1', pula));
            };
            var p = [zdanie(gor, T.gor), zdanie(zim, T.zim)];
            if (o.poza == null) { p.push(T.pasmoN); }
            else if (o.poza.length) { p.push(T.pasmoP.replace('%1', o.poza.join(', '))); }
            else { p.push(T.pasmoB); }
            return p;
        },
        render: function (okno, klucz, dane) {
            var q = function (s) { return document.querySelector(s); };
            var qa = function (s) { return document.querySelectorAll(s); };
            var sekcja = q('[data-gorace-zimne]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var N = okno.losowan || 0, liczby = okno.liczby || {}, pula = (dane && dane.pula) || window.PEWNIAKI_ANALIZA.pula;
            Array.prototype.forEach.call(qa('[data-gorace-zimne-n]'), function (el) { el.textContent = tys(N); });
            q('[data-gorace-zimne-e]').textContent = fmt(okno.e, 1);
            q('[data-gorace-zimne-sd]').textContent = fmt(okno.sd, 2);
            q('[data-gorace-zimne-maxz]').textContent = fmt(okno.max_z, 2);
            var klucze = Object.keys(liczby).map(Number);
            var wiersz = function (n) {
                var w = liczby[n];
                return '<tr><td><div class="kula-z-podpisem"><span class="kula kula--' + cfg.kod + '">' + n + '</span></div></td>'
                     + '<td class="liczbowa">' + (w.hits == null ? '—' : tys(w.hits)) + '</td>'
                     + '<td class="liczbowa">' + fmt(w.e, 1) + '</td>'
                     + '<td class="liczbowa">' + fmt(w.z, 2) + '</td></tr>';
            };
            var gorace = klucze.slice().sort(function (a, b) { return liczby[b].hits - liczby[a].hits || a - b; }).slice(0, 10);
            var zimne = klucze.slice().sort(function (a, b) { return liczby[a].hits - liczby[b].hits || a - b; }).slice(0, 10);
            q('[data-gorace-zimne-gorace] tbody').innerHTML = gorace.map(wiersz).join('');
            q('[data-gorace-zimne-zimne] tbody').innerHTML = zimne.map(wiersz).join('');
            q('[data-gorace-zimne-model]').textContent = (okno.e != null && okno.sd != null)
                ? T.model.replace('%1', pula).replace('%2', fmt(okno.e, 1)).replace('%3', tys(N)).replace('%4', fmt(okno.sd, 2))
                : T.brakE;
            q('[data-gorace-zimne-poza]').textContent = okno.poza == null
                ? T.pasmoN2
                : (okno.poza.length ? T.pasmoP2.replace('%1', okno.poza.join(', ')) : T.pasmoB2);
        }
    };
})();
